
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import Editor from '@tinymce/tinymce-vue';
import Store from '@/store/index';
import AppConst from '@/lib/appConst';
import common from '@/lib/common';
import Order from '@/store/entities/ordering/Order';
import OrderItemEditingList from '@/components/ordering/OrderItem-editing-list.vue';

@Component({
    components: {
        Editor,
        OrderItemEditingList,
    }
})
export default class EditOrder extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: String, default: "Create" }) editMode: string;

    currentTab: string = "detail";
    title: string = this.L('Order');
    order: Order = new Order();
    editorOptions: any = {
        plugins: 'image',
        image_uploadtab: true,
        height: 400,
        images_upload_handler: function (blobInfo, success, failure) {
            var formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            formData.append('usage', 'OrderingOrderEditors');
            var location = Store.dispatch({
                type: 'imageManager/uploadImage',
                data: formData
            });
            success(location);
        }
    };
    uploadHeaders: any = {
        Authorization: "Bearer " + Util.abp.auth.getToken(),
        TenantId: Util.abp.multiTenancy.getTenantIdCookie()
    };
    uploadUrl: string = '';
    orderItemEditingListVisible: boolean = true;//abp.auth.isGranted("Pages.OrderItem");
    saveLoading: boolean = false;

    save() {
        (this.$refs.orderForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.saveLoading = true;
                await this.$store.dispatch({
                    type: 'order/' + this.editMode.toLowerCase(),
                    data: this.order
                }).then(() => {
                    this.$emit('save-success');
                    this.$emit('input', false);
                    this.saveLoading = false;
                }).catch((err) => {
                    console.log('err!');
                    this.saveLoading = false;
                });
            }
        })
    }
    cancel() {
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
            //Util.refresh(this);
        } else {
            this.currentTab = "detail";
            this.uploadUrl = common.getUploadUrl('OrderingOrder');
            if (this.editMode.toLowerCase() === "create") {
                this.title = this.L('Create') + this.L('Order');
                var model = new Order();
                model.orderItems = [];
                this.order = Util.extend(true, {}, model);
                (this.$refs.orderForm as any).resetFields();
            } else if (this.editMode.toLowerCase() === "update") {
                this.title = this.L('Edit') + this.L('Order');
                this.order = Util.extend(true, {}, this.$store.state.order.editOrder);
            } else {
                this.$Modal.error({ title: this.L('Tips'), content: 'Unknow edit mode. thie edit mode should be "Create" or "Update"' });
            }
        }
    }
    handleTabChanged(e) {
        this.currentTab = e;
    }
    handleBeforeUpload(file) {
        var validationResult = Util.validateImageFile(file);
        if (!validationResult.result) {
            this.$Notice.warning({
                title: this.L('Tips'),
                desc: validationResult.msg
            });
            return false;
        }
        return true;
    }
    handleRemoveImage(fileName: string, onRemoved) {
        this.$Modal.confirm({
            title: this.L('Tips'),
            content: this.L("DeleteConfirm", fileName),
            onOk: () => {
                this.$store.dispatch({
                    type: 'imageManager/deleteImage',
                    data: {
                        imageUrl: fileName
                    }
                }).then(() => {
                    if (onRemoved) {
                        onRemoved();
                    }
                    this.$Notice.success({
                        title: this.L('Tips'),
                        desc: fileName + this.L('Delete') + this.L('Success')
                    });
                });
            }
        });
    }

    orderRule = {
        addressId: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('AddressId')) }],
        wxUserId: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('WxUserId')) }],
        userId: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('UserId')), trigger: 'blur' }],
        userName: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('UserName')), trigger: 'blur' }],
        paymentMethod: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('PaymentMethod')), trigger: 'blur' }],
        status: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('Status')) }],
        addressInfo: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('AddressInfo')), trigger: 'blur' }],
        shipmentStatus: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('ShipmentStatus')) }],
        paidAmount: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('PaidAmount')) }],
    }
}
